import { useParams } from 'react-router'
import PractitionerPayoutReceipts from 'src/supportPortal/components/common/mentor/payoutInvoice/PractitionerPayoutReceipts'

export default function TherapistPayoutReceipts() {
  const { mentorSlug } = useParams()
  return (
    <PractitionerPayoutReceipts
      fetchSingleMentorSignature={`/api/secure/cc/support/therapists/by-slug?mentor-slug=${mentorSlug}`}
      mentorSlug={mentorSlug}
    />
  )
}
